import moment from 'moment'

export type RentalAddOnFormValues = {
  amount: string
  endDate: string
  hasLiabilityType?: boolean
  occupancyDate: string
  startDate: string
}

export type RentalAddOnFormErrors = {
  amount?: string
  endDate?: string
  liabilityType?: string
  startDate?: string
}

const parseDate = (date: string) => moment(date, 'YYYY-MM-DD', true)

export const formatDateForInput = (value: string | null | undefined) => {
  if (!value) {
    return ''
  }

  const parsedDate = parseDate(value)
  return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : ''
}

export const getRentalAddOnFormErrors = ({
  amount,
  endDate,
  hasLiabilityType = true,
  occupancyDate,
  startDate
}: RentalAddOnFormValues): RentalAddOnFormErrors => {
  const errors: RentalAddOnFormErrors = {}
  const numericAmount = Number(amount)
  const parsedStartDate = parseDate(startDate)
  const parsedEndDate = parseDate(endDate)
  const parsedOccupancyDate = parseDate(occupancyDate)

  if (!hasLiabilityType) {
    errors.liabilityType = 'Select an add-on type.'
  }

  if (!amount) {
    errors.amount = 'Amount is required.'
  } else if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
    errors.amount = 'Enter an amount greater than $0.00.'
  }

  if (!startDate) {
    errors.startDate = 'Start date is required.'
  } else if (!parsedStartDate.isValid()) {
    errors.startDate = 'Enter a valid start date.'
  } else if (!parsedOccupancyDate.isValid()) {
    errors.startDate = `The occupancy date ${occupancyDate || ''} is not valid.`
  } else if (!parsedStartDate.isSameOrAfter(parsedOccupancyDate, 'day')) {
    errors.startDate = `Start date must be on or after the occupancy date (${occupancyDate}).`
  }

  if (endDate) {
    if (!parsedEndDate.isValid()) {
      errors.endDate = 'Enter a valid end date.'
    } else if (parsedStartDate.isValid() && parsedEndDate.isBefore(parsedStartDate, 'day')) {
      errors.endDate = 'End date must be on or after the start date.'
    }
  }

  return errors
}

export const hasRentalAddOnFormErrors = (errors: RentalAddOnFormErrors) =>
  Object.values(errors).some(Boolean)
